import '../css/Admin.css';
import Footer from './Footer';
import Header from './Header';
import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

function Admin() {
    const navigate = useNavigate();
    const location = useLocation(); // 현재 경로 감지

    return (
        <div className="Admin-container">
            <Header />
            <div className="admin-container">
                {/* 왼쪽 사이드 버튼 */}
                <div className="admin-left-container">
                    <div
                        className={`admin-contents-container ${location.pathname === "/admin/update" ? "active" : ""}`}
                    >
                        <button onClick={() => navigate("/admin/update")}>
                            업데이트
                        </button>
                    </div>
                </div>

                {/* 오른쪽 영역 (하위 라우트 표시) */}
                <div className="admin-detail-container">
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Admin;
